<script setup lang="ts">
import ToastContainer from "@/components/Toast/Container.vue";
</script>

<template>
  <router-view />
  <ToastContainer />
</template>
